
<template>
  <el-table
    :data="lczs"
    stripe
    size="mini"
  >
    <el-table-column
      label="Location"
    >
      <template slot-scope="scope">
        {{ scope.row.location.suburb }}, {{ scope.row.location.state }},  {{ scope.row.location.postcode }}, {{ scope.row.location.country }}
      </template>
    </el-table-column>
    <el-table-column
      label="Zone"
      prop="zone.desc"
      sortable
    >
      <template slot-scope="scope">
        {{ (scope.row.zone.desc) ? scope.row.zone.desc:'-' }}
      </template>
    </el-table-column>
    <el-table-column
      label="Parent Zone"
      prop="zone_parent.desc"
      sortable
    >
      <template slot-scope="scope">
        {{ (scope.row.zone_parent)? scope.row.zone_parent.desc : '-' }}
      </template>
    </el-table-column>
    <el-table-column
      label="Hub/Depot"
      prop="hub.desc"
      sortable
    >
      <template slot-scope="scope">
        {{ (scope.row.hub)? scope.row.hub.desc : '-' }}
      </template>
    </el-table-column>
    <el-table-column
      label="Remote"
      prop="zone_remote"
      :formatter="(row, col, cellValue) => cellValue ? cellValue : '-'"
    />
    <el-table-column
      label="Modified By"
    >
      <template slot-scope="scope">
        {{ (scope.row.user)? scope.row.user.name : '-' }}
      </template>
    </el-table-column>
    <el-table-column
      v-if="canUpdate || canDelete"
      label="Actions"
      align="right"
    >
      <template slot-scope="scope">
        <el-button
          v-if="canUpdate"
          size="mini"
          @click.native="$emit('edit', scope.row)"
        >
          Edit
        </el-button>
        <el-button
          v-if="canDelete"
          size="mini"
          type="danger"
          @click.native="deleteLCZ(scope.$index, scope.row)"
        >
          Delete
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { UPDATE, DELETE } from '@/plugins/user'
export default {
  props: {
    lczs: {
      type: Array,
      required: true,
      default: null
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'carrier_locationzone')
    },
    canDelete () {
      return this.$user.can(DELETE, 'carrier_locationzone')
    }
  },
  methods: {
    deleteLCZ (index, row) {
      this.$confirm('Are you sure to delete this Location Carrier Zone ?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        row.delete(builder => {
          builder.context = { resource: 'pivot' }
        })
          .then(res => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.$emit('refresh'))
      }).catch(() => {})
    }
  }
}
</script>
